import { render, staticRenderFns } from "./EventWrapper.vue?vue&type=template&id=95f6473e&scoped=true"
import script from "./EventWrapper.vue?vue&type=script&lang=js"
export * from "./EventWrapper.vue?vue&type=script&lang=js"
import style0 from "./EventWrapper.vue?vue&type=style&index=0&id=95f6473e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f6473e",
  null
  
)

export default component.exports